module.exports = __webpack_public_path__ + "d664201f/img/question-icon.06c20c5d.svg";